export default __webpack_public_path__ + "static/media/WalkwayRamp.256.4962592d.png";